import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { EnvelopeIcon, MapPinIcon, PencilSimpleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { IconButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LogisticInfo = ({
  shippingMethod,
  carrierName,
  carrierLogo,
  isPickupPoint,
  showShippingMethod = true,
  onSendEmailToCarrier,
  allowSendEmail,
  onEditCarrierService,
  allowEditCarrierService,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.SectionContainer>
      <Styles.SectionTitleContainer>
        <Text type="titleS">{t('Logística')}</Text>
        {allowSendEmail && (
          <Styles.ActionsTitleContainer>
            <Tooltip title={t('Contactar con el transportista')}>
              <IconButton
                variant="text"
                icon={
                  <EnvelopeIcon
                    alt={t('Contactar con el transportista')}
                    size={24}
                    color={theme.colors.outline.default}
                  />
                }
                onClick={onSendEmailToCarrier}
              />
            </Tooltip>
            {allowEditCarrierService && (
              <Tooltip title={t('Editar servicio de logística')}>
                <IconButton
                  variant="text"
                  icon={
                    <PencilSimpleIcon
                      alt={t('Editar servicio de logística')}
                      size={24}
                      color={theme.colors.outline.default}
                    />
                  }
                  onClick={onEditCarrierService}
                />
              </Tooltip>
            )}
          </Styles.ActionsTitleContainer>
        )}
      </Styles.SectionTitleContainer>
      <Styles.SectionInfoContainer>
        <Styles.InfoColumnContainer>
          <Styles.InfoContainer>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {t('Servicio de logística')}
            </Text>
            <Styles.CarrierLogo src={carrierLogo} alt="carrier logo" />
            <Text type="bodyMRegular">{carrierName}</Text>
            <Text type="bodyMRegular">{shippingMethod?.carrier?.service_name}</Text>
          </Styles.InfoContainer>
        </Styles.InfoColumnContainer>
        {showShippingMethod && (
          <Styles.InfoColumnContainer>
            <Styles.InfoContainer>
              <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                {t('Método de envío')}
              </Text>
              {isPickupPoint && (
                <Styles.PickupPointInfo>
                  <MapPinIcon weight="light" size={20} />
                  <Text type="bodyMRegular">{t('Punto de recogida')}</Text>
                </Styles.PickupPointInfo>
              )}
              <Text type="bodyMRegular">{shippingMethod?.name}</Text>
            </Styles.InfoContainer>
          </Styles.InfoColumnContainer>
        )}
      </Styles.SectionInfoContainer>
    </Styles.SectionContainer>
  )
}

export default LogisticInfo
